import store from '@/store';
import MessageType from '@/models/MessageType';

export function can(permission: string): boolean {
    return store.getters['auth/hasPermission'](permission);
}

export function requirePerm(permission: string, callback: () => void): void {
    if (can(permission)) {
        callback();
    } else {
        store.dispatch('addMessage', {
            message: "You don't have permission to perform this action.",
            type: MessageType.error,
            autoClose: true,
        });
    }
}

export default {
    install(app: any) {
        app.config.globalProperties.$can = can;
        app.config.globalProperties.$requirePerm = requirePerm;

        app.directive('can', {
            mounted(el: HTMLElement, binding: { value: string }) {
                if (!can(binding.value)) {
                    el.style.display = 'none';
                }
            },
            updated(el: HTMLElement, binding: { value: string }) {
                el.style.display = can(binding.value) ? '' : 'none';
            },
        });
    },
};
